Vendd.Scripts.load(function () {

    $.extend($.fn, {
        pdControlDisabled: function (toggleValue) {
            if (toggleValue === undefined) {
                return this.prop('disabled') || this.hasClass('disabled');
            }
            this.toggleClass('disabled', toggleValue).prop('disabled', toggleValue);
            return this;
        },

        pdQuantitySelector: function (options) {
            options = $.extend({
                min: 0,
                max: undefined,
                step: 1,
                value: 0
            }, options);

            var useFloats = isFloat(options.min) || isFloat(options.max) || isFloat(options.step);

            function isFloat(value) {
                return value && parseFloat(value).toFixed(2) !== parseInt(value).toFixed(2);
            }

            this.each(function (i, control) {
                var $control = $(control);
                var $decr = $('.js-qty-decr', $control);
                var $incr = $('.js-qty-incr', $control);
                var $input = $('.js-qty-input', $control);
                var $select = $('.js-qty-select', $control);

                var step = clipNumber(parseNumber(options.step) || 1, parseNumber(options.min) || 1, parseNumber(options.max) || 99999);
                var min = roundNumber(parseNumber(options.min) || 0, step);
                var max = roundDownNumber(parseNumber(options.max) || 99999, step); // A really "large" number.
                var value = updateValue(parseNumber(options.value));

                if (!isTouch()) {
                    // NOTE: Might require additional styling.
                    // $select.sSelect();
                }

                // Methods

                control.quantity = function () {
                    return value;
                };

                // Bindings

                $decr.on('click', function () {
                    if (!$decr.pdControlDisabled()) {
                        updateValue(getValue() - step);
                    }
                });

                $incr.on('click', function () {
                    if (!$incr.pdControlDisabled()) {
                        updateValue(getValue() + step);
                    }
                });

                $input.on('focusout', function () {
                    updateValue(getValue() || value);
                });

                $input.on('keyup', function (e) {
                    if (e.keyCode === 13) {
                        updateValue(getValue());
                    }
                });

                $select.on('change', function (e) {
                    updateValue(getValue());
                });

                // Private methods (helpers)

                function isReadOnly() {
                    return $input.prop('readonly') || $select.prop('readonly');
                }

                function updateValue(newValue) {
                    newValue = setValue(newValue);

                    if (value !== newValue) {
                        var oldValue = value;
                        value = newValue;

                        $decr.pdControlDisabled(isReadOnly() || value <= min);
                        $incr.pdControlDisabled(isReadOnly() || max <= value);

                        if (oldValue !== undefined) {
                            $control.trigger('product:change');
                        }
                    }

                    return newValue;
                }

                function getValue() {
                    return parseNumber($input.val() || $select.val());
                }

                function setValue(value) {
                    value = parseNumber(value) || min;
                    value = roundNumber(value, step);
                    value = clipNumber(value, min, max);
                    $input.val(formatNumber(value));
                    return value;
                }

                function roundNumber(value, step) {
                    return Math.round(value / step) * step;
                }

                function roundDownNumber(value, step) {
                    return value - (value % step);
                }

                function clipNumber(value, minValue, maxValue) {
                    return Math.min(Math.max(minValue, value), maxValue);
                }

                function parseNumber(value) {
                    return useFloats ? parseFloat(value) : parseInt(value);
                }

                function formatNumber(value) {
                    return useFloats ? value.toFixed(2) : value;
                }
            });

            return this;
        }
    });
});